import { DeliverynoteType } from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'
import { ReceiptType } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'
import { FieldsInterface, Locales } from 'client/Interfaces/Draft/FieldsInterface'

import { CustomerInterface } from '../../CustomerInterface'
import { InvoiceItemType } from '../DraftItemType'
import { DraftFieldsInterface } from '../FieldsInterface'
import { SummaryInterface } from './SummaryInterface'

export type Language = 'nl' | 'en' | 'fi' | 'sv' | 'fr' | 'de'

export interface Discount {
  amount: number
  type: ['precentage', 'amount']
  vat: ['preVAT', 'postVAT']
  location: ['preLine', 'preTotal']
}

interface LogoInterface {
  [x: string]: any
  _id: string
  content: string
}

interface TradeNameInterface {
  _id: string
  logo?: LogoInterface
  name?: string
}

export interface CompanyV1Interface {
  tradeName: TradeNameInterface
}

export interface ConfigInterface {
  mobileCanEdit?: boolean
  invoiceNumber?: string
  fields?: FieldsInterface
}

export interface AvailableFieldDefaultsInterface {
  title: Record<Partial<Locales>, string>
}

export interface InvoiceDraftInterface {
  discount: Discount
  approvedEstimateId: number
}

export enum DiscountVAT {
  PreVat = 'preVAT',
  PostVat = 'postVAT',
}

export enum DiscountType {
  Percentage = 'percentage',
  Amount = 'amount',
}

export enum DiscountLocation {
  Line = 'perLine',
  Total = 'perTotal',
}

export interface DiscountInterface {
  total: number
  amount: number
  type: DiscountType
  vat: DiscountVAT
  location: DiscountLocation
}

export enum DocumentTypes {
  RECEIPT = 'receiptDraft',
  DELIVERYNOTE = 'deliverynoteDraft',
}

export type DocumentType = ReceiptType.draft | DeliverynoteType.draft

export interface DraftCommonInterface {
  customer: CustomerInterface
  issueDate: string
  language: Language
  lines: InvoiceItemType[]
  id?: number
  invoiceNumber?: string
  summary?: SummaryInterface
  locale?: Locales
  description?: string
  footerText?: string
  dueDate?: string
  company?: CompanyV1Interface
  referenceNumber?: string
  invalidFields?: string[]
  config?: ConfigInterface
  discount?: DiscountInterface
  fields?: DraftFieldsInterface
  documentType?: DocumentType
  dirty?: boolean
  title?: string | null
}
